/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Meta_TitleInputs */

const en_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices | Mark Egly Golf`)
};

const es_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios | Mark Egly Golf`)
};

const de_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise | Mark Egly Golf`)
};

const zh_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格 | Mark Egly Golf`)
};

const ar_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار | Mark Egly Golf`)
};

const fr_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs | Mark Egly Golf`)
};

const vi_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá | Mark Egly Golf`)
};

const sw_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei | Mark Egly Golf`)
};

const th_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา | Mark Egly Golf`)
};

const bs_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene | Mark Egly Golf`)
};

const ja_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格 | Mark Egly Golf`)
};

const ko_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 | Mark Egly Golf`)
};

const pt_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços | Mark Egly Golf`)
};

const it_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi | Mark Egly Golf`)
};

const sv_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser | Mark Egly Golf`)
};

const nl_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen | Mark Egly Golf`)
};

const da_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser | Mark Egly Golf`)
};

const nb_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser | Mark Egly Golf`)
};

const fi_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat | Mark Egly Golf`)
};

const pl_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny | Mark Egly Golf`)
};

const ru_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены | Mark Egly Golf`)
};

const tr_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlar | Mark Egly Golf`)
};

const hi_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य | Mark Egly Golf`)
};

const id_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga | Mark Egly Golf`)
};

const ms_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga | Mark Egly Golf`)
};

const cs_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny | Mark Egly Golf`)
};

const el_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές | Mark Egly Golf`)
};

const he_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירים | Mark Egly Golf`)
};

const af_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse | Mark Egly Golf`)
};

const hu_prices_meta_title = /** @type {(inputs: Prices_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árak | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Prices \| Mark Egly Golf" |
*
* @param {Prices_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_meta_title = /** @type {((inputs?: Prices_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_meta_title(inputs)
	if (locale === "de") return de_prices_meta_title(inputs)
	if (locale === "zh") return zh_prices_meta_title(inputs)
	if (locale === "ar") return ar_prices_meta_title(inputs)
	if (locale === "fr") return fr_prices_meta_title(inputs)
	if (locale === "vi") return vi_prices_meta_title(inputs)
	if (locale === "sw") return sw_prices_meta_title(inputs)
	if (locale === "th") return th_prices_meta_title(inputs)
	if (locale === "bs") return bs_prices_meta_title(inputs)
	if (locale === "ja") return ja_prices_meta_title(inputs)
	if (locale === "ko") return ko_prices_meta_title(inputs)
	if (locale === "pt") return pt_prices_meta_title(inputs)
	if (locale === "it") return it_prices_meta_title(inputs)
	if (locale === "sv") return sv_prices_meta_title(inputs)
	if (locale === "nl") return nl_prices_meta_title(inputs)
	if (locale === "da") return da_prices_meta_title(inputs)
	if (locale === "nb") return nb_prices_meta_title(inputs)
	if (locale === "fi") return fi_prices_meta_title(inputs)
	if (locale === "pl") return pl_prices_meta_title(inputs)
	if (locale === "ru") return ru_prices_meta_title(inputs)
	if (locale === "tr") return tr_prices_meta_title(inputs)
	if (locale === "hi") return hi_prices_meta_title(inputs)
	if (locale === "id") return id_prices_meta_title(inputs)
	if (locale === "ms") return ms_prices_meta_title(inputs)
	if (locale === "cs") return cs_prices_meta_title(inputs)
	if (locale === "el") return el_prices_meta_title(inputs)
	if (locale === "he") return he_prices_meta_title(inputs)
	if (locale === "af") return af_prices_meta_title(inputs)
	if (locale === "hu") return hu_prices_meta_title(inputs)
	return en_prices_meta_title(inputs)
});